import type { Context } from "@/common/types/router"
import { baseRoute } from "@/common/router/baseRoutes"
import commonRepository from "@/common/repository/CommonRepository"
import { isValidRoute } from "@/common/utils/lib"

const requireConfig = () => {
    return async ({ to, next, nextMiddleware, useConfig }: Context) => {
        const configStore = useConfig()

        if (configStore.getVariant() === undefined) {
            try {
                configStore.setConfig(await commonRepository.getConfig())
            } catch (e) {
                return next({ name: baseRoute.error.name })
            }
        }

        return isValidRoute(to.meta, configStore.getVariant(), configStore.isEvent())
            ? nextMiddleware()
            : next({ name: baseRoute.forbidden.name })
    }
}

export default requireConfig
